import React, { Component } from 'react'
import Signup from '../../components/signup/Signup';

class SignupContainer extends Component {
  handleClickShowPassword = (is_show) => {
    this.props.setShowPassword(is_show)
  };
  componentWillUnmount(){
    this.props.setResetState();
  }

  handleSignUp = (payload) => {
    let res = this.props.signup(payload);
    return res
  }

  render() {
    const {signup_is_loading,show_password,company_details} = this.props;
    return (
      <Signup
      signup_is_loading = {signup_is_loading}
      show_password = {show_password}
      handleClickShowPassword = {this.handleClickShowPassword}
      handleSignUp = {this.handleSignUp}
      company_details = {company_details}
      />
    )
  }
}

export default SignupContainer;
